import React from 'react';
import DatePicker from 'react-datepicker';
import { ErrorMessage } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';

const FormikDatePicker = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  id,
  placeholder,
  label,
  ...rest
}) => {
  let formatedDate = '';

  if (value) {
    formatedDate = new Date(value);
  }

  const handleChange = (date) => {
    setFieldValue(name, date, true);
  };

  // const ExampleCustomTimeInput = ({ date, value, onChange }) => (
  //   <input
  //     value={value}
  //     onChange={(e) => onChange(e.target.value)}
  //     style={{ border: 'solid 1px pink' }}
  //   />
  // );

  return (
    <FormGroup className="flex-grow-1">
      {label && (
        <Label for={name} className="d-block">
          {label}
        </Label>
      )}
      <DatePicker
        id={id}
        invalid={Boolean(touched[name] && errors[name])}
        selected={formatedDate}
        onChange={handleChange}
        name={name}
        placeholderText={placeholder}
        className="form-control"
        timeFormat="HH:mm"
        dateFormat="yyyy/MM/dd HH:mm"
        // showTimeInput
        // customTimeInput={<ExampleCustomTimeInput />}
        {...rest}
      />
      <ErrorMessage
        name={name}
        render={(msg) => <div className="text-danger font-size-12">{msg}</div>}
      />
    </FormGroup>
  );
};
export default FormikDatePicker;
